module.exports = function() {
  return new Worker(__webpack_public_path__ + "04af5b98f7823ca45b2a.worker.js");
};